module.exports = __webpack_public_path__ + "static/media/calculator-plain.5dd4fcda.svg";